export class AppSettings {
  // =========================
  // Environment Base URLs
  // =========================

  // Staging
  // public static baseWeb = "https://dev-web-server.bluewings.in";
  // public static baseMobile = "https://dev-mobile-server.bluewings.in";

  // Production
  public static baseWeb = "https://apip240613.bluewings.in";
  public static baseMobile = "https://apipm240620.bluewings.in";


  // =========================
  // API Endpoints
  // =========================

  public static API_ENDPOINT = `${this.baseWeb}/api/v1`;
  public static API_ENDPOINT_V3 = `${this.baseWeb}/api/v3`;

  public static API_ENDPOINT_STAFF = `${this.baseMobile}/api/v3`;
  public static API_ENDPOINT_STAFF_BASE = this.baseMobile;
}
